module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Folder-minus-496b6a72f09675ce22166a78d1bb85ed.svg";